/* eslint-disable camelcase */
import { isEmpty } from 'lodash';
import API from './api';
import { services } from '~/config/constants';

const { coreService } = services;

export const logError = async (
    screen: string,
    data: {
        message?: string;
        email?: string;
        user_id?: string;
    }
) => {
    if (data.user_id) {
        delete data.email;
    } else {
        delete data.user_id;
    }

    if (data.email) {
        data.email = data.email.toLowerCase();
    }

    return await API({
        endpoint: `${coreService}/${data?.user_id ? 'user-id' : 'email'}/${
            !isEmpty(screen) ? screen?.replaceAll('/', '_') : 'welfare'
        }/logs`,
        method: 'POST',
        data,
    });
};
